// extracted by mini-css-extract-plugin
export default {"loading":"progressive-image_loading__bsyjR","loaded":"progressive-image_loaded__XjfYb","loader":"progressive-image_loader__KOFeI"};